import React from "react";
import { useQuery } from "@apollo/react-hooks";
import lookup from "country-code-lookup";

import BarChart from "components/chart/BarChart";
import LineChart from "components/chart/LineChart";
import PieChart from "components/chart/PieChart";
import GeoChart from "components/chart/GeoChart";
import TreeMap from "components/chart/TreeMap";
import Layout from "components/Layout";
import Scrollable from "components/Scrollable";
import withAuth from "components/withAuth";
import { mapData, sortData } from "components/DataTable";
import { H2, Section } from "styles";
import { AVERAGE, SOURCE, YEAR, COUNTRY, ETHNICITY } from "queries";

function Home() {
  const { data: { average } = { average: [] } } = useQuery(AVERAGE);
  const { data: { sources } = { sources: [] } } = useQuery(SOURCE);
  const { data: { years } = { years: [] } } = useQuery(YEAR);
  const { data: { countries } = { countries: [] } } = useQuery(COUNTRY);
  const { data: { ethnicities } = { ethnicities: [] } } = useQuery(ETHNICITY);

  const aggregation = {};
  const averageYears = Object.keys(average);
  Object.values(average).map(
    ({ average }: any, index) => (aggregation[averageYears[index]] = average)
  );

  const AgeData = mapData(aggregation, true);
  const sourceData = sortData(mapData(sources), "value");
  const yearData = mapData(years);

  const countryData = Object.entries(
    ethnicities
  ).map(([ethnicity, count]: any) => [lookup.byIso(ethnicity).country, count]);

  countryData.unshift(["Ethnicity", "Count"]);

  const byIso = {};

  Object.entries(countries)
    .map(([country, count]) => ({
      [lookup.byIso(country).country]: count,
    }))
    .map((item) => Object.assign(byIso, item));

  const chartData = mapData(byIso);

  return (
    <Layout fullWidth>
      <Section width={25}>
        <H2>Average age per year </H2>
        {AgeData && (
          <Scrollable>
            <LineChart data={AgeData} width={400} />
          </Scrollable>
        )}
      </Section>
      <Section width={30}>
        <H2>Source </H2>
        {sourceData && (
          <Scrollable>
            <PieChart data={sourceData} />
          </Scrollable>
        )}
      </Section>
      <Section width={24}>
        <H2>Year </H2>
        {yearData && (
          <Scrollable>
            <BarChart data={yearData} width={400} />
          </Scrollable>
        )}
      </Section>
      <Section width={38}>
        <H2>Ethnicities</H2>
        <Scrollable>
          <GeoChart data={countryData} />
        </Scrollable>
      </Section>
      <Section width={38}>
        <H2>Countries</H2>
        <Scrollable>
          <TreeMap data={chartData} />{" "}
        </Scrollable>
      </Section>
    </Layout>
  );
}

export default withAuth(Home);
